import { getPublicPara, setMsgBadge, urlList } from '../../api/api'
import axios from 'axios'
import { baseUrlApi, resCode } from '../../api/common'
const msgBadge = {
  state: {
    msgBadge: null
  },
  mutations: {
    MSGBADGE (state, info) {
      if (info) {
        state.msgBadge = info
      } else {
        state.msgBadge = null
      }
    }
  },
  getters: {
    msgBadge: state => state.msgBadge
  },
  actions: {
    MSGBADGEACTION ({ commit }) {
      const options = {
        method: 'post',
        url: baseUrlApi + '/' + urlList.getSelfAllNoReadTotal,
        data: getPublicPara(),
        json: true
      }
      axios(options).then(({ data }) => {
        if (data) {
          if (data.code === resCode.OK) {
            const msgBadge = data.total
            setMsgBadge(msgBadge)
            commit('MSGBADGE', msgBadge)
          }
        }
      })
    }
  }
}

export default msgBadge
